// Per-unit CSS-filter tints for cases where two units share a glyph
// and need visual differentiation. Each entry is a CSS `filter` value
// appended to ImgGlyph's default drop-shadow.
//
// Authoring tip: pick a `hue-rotate(...)` first (180deg = complement),
// then nudge `saturate(...)` to keep contrast. Strong color shifts
// look unnatural on bitmap art; tints in the 0.7-0.9 saturate range
// stay grounded.
//
// Add new entries here when a unit ships sharing another's glyph; the
// JSON catalog doesn't need a schema change.

export const UNIT_TINTS: Record<string, string> = {
  // No active tints today — every catalog member with bitmap art
  // ships its own dedicated glyph key. Placeholder tints previously
  // applied to banky_pig / gold_fish / wolf_spider were dropped when
  // their `pig` / `goldfish` / `spider` glyph keys + bitmap art
  // landed.
}
